export enum EProfileUrls {
  PROFILE = 'profile',
  PROFILE_PICTURE = 'profile-picture',
  NAME = 'name',
}
